//@flow

// Vendors
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components
import { Modal, FormActions, FormActionsItem, Content } from '../../..';
import { ButtonPrimary, TextButton } from 'texkit/dist/components/Buttons';

// Actions
import { closeModal } from '../../../../reducers/modal/modalActions';

// Styles
import './account-exists-modal.scss';

type Props = {
  existingEmail: string,
  onAccept: Function,
  onReject: Function,
  closeModal: Function,
};

const AccountExistsModal = ({
  existingEmail,
  onAccept,
  onReject,
  closeModal,
}: Props) => {
  const modalName = 'AccountExistsModal';

  return (
    <Modal
      name={modalName}
      disableOnClickOutside="true"
      disableCloseButton="true"
      className="modal-sm account-exists-modal"
    >
      <h2 className="h1 modal-title">
        <Content type="Modals" id="EmailAlreadyRegistered" />
      </h2>
      <div className="modal-content">
        <div className="account-exists-modal-email">{existingEmail}</div>
        <FormActions align="center">
          <FormActionsItem fullWidth={true}>
            <ButtonPrimary
              onClick={() => {
                closeModal(modalName);
                onAccept(existingEmail);
              }}
            >
              <Content type="Labels" id="SignIn" />
            </ButtonPrimary>
          </FormActionsItem>
          <FormActionsItem fullWidth={true}>
            <TextButton
              onClick={() => {
                closeModal(modalName);
                onReject();
              }}
            >
              <Content type="Labels" id="CheckSpellingAndTryAgain" />
            </TextButton>
          </FormActionsItem>
        </FormActions>
      </div>
    </Modal>
  );
};

const mapDispatchToProps = (dispatch: Object) =>
  bindActionCreators({ closeModal }, dispatch);

export default connect(null, mapDispatchToProps)(AccountExistsModal);
